'use client';

import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';

interface SignedOutProps {
  children: ReactNode;
}

export function SignedOut({ children }: SignedOutProps) {
  const { isAuthenticated } = useAuth();
  
  if (isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}